// @vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');

// @constants
const actionTypes = require('../constants/actionTypes');
const {
    BROKER_FUND_LEGAL_DOCUMENT_DOCUMENT_TYPE_FUNDAMENTAL_DATA_INVESTOR,
    BROKER_FUND_LEGAL_DOCUMENT_DOCUMENT_TYPE_SEMI_ANNUAL_REPORT,
    BROKER_FUND_LEGAL_DOCUMENT_SEMIANUAL_REPORT,
    BROKER_FUND_LEGAL_DOCUMENT_DFI,
} = require('constants/index');

function setInitialState() {
    return Immutable.fromJS({
        byId: {},
        activeIsin: '',
    });
}

// @helpers
const apiURLBuilder = require('core/apiURLBuilder');

function getMorningStarsDocumentsLinks(response) {
    const responseDocuments = get(response, '[0].Documents');
    let documents = {};

    if (responseDocuments) {
        const fundamentalDataForInvestor = responseDocuments.find(
            immDoc =>
                get(immDoc, ['DocumentTypes', 0]) ===
                BROKER_FUND_LEGAL_DOCUMENT_DOCUMENT_TYPE_FUNDAMENTAL_DATA_INVESTOR,
        );
        const semiAnnualReport = responseDocuments.find(
            immDoc =>
                get(immDoc, ['DocumentTypes', 0]) ===
                BROKER_FUND_LEGAL_DOCUMENT_DOCUMENT_TYPE_SEMI_ANNUAL_REPORT,
        );

        documents = {
            isFetched: true,
            isFetching: false,
            fundamentalDataForInvesorUrl: fundamentalDataForInvestor
                ? apiURLBuilder.getURL('morningstarFundLegalDocumentUrl', {
                      isin: get(
                          fundamentalDataForInvestor,
                          'EncodedDocumentId',
                      ),
                      documentType: BROKER_FUND_LEGAL_DOCUMENT_DFI,
                  })
                : '',
            semiAnnualReportUrl: semiAnnualReport
                ? apiURLBuilder.getURL('morningstarFundLegalDocumentUrl', {
                      isin: get(semiAnnualReport, 'EncodedDocumentId'),
                      documentType: BROKER_FUND_LEGAL_DOCUMENT_SEMIANUAL_REPORT,
                  })
                : '',
        };
    }

    return documents;
}

function cmLegalDocumentsReducer(state = setInitialState(), action) {
    switch (action.type) {
        case actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_SUCCESS:
            return state.mergeDeep({
                byId: {
                    [action.payload.isin]: getMorningStarsDocumentsLinks(
                        action.payload.response,
                    ),
                },
                activeIsin: action.payload.isin,
            });
        case actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_REQUEST:
            return state.mergeDeepIn(['byId', action.payload.isin], {
                isFetched: false,
                isFetching: true,
            });
        case actionTypes.CM_LEGAL_DOCUMENT_MORNING_STAR_EXT_FETCH_FAILURE:
            return state.mergeDeepIn(['byId', action.payload.isin], {
                isFetched: true,
                isFetching: false,
                error: action.payload.error,
            });
        case actionTypes.CM_LEGAL_DOCUMENT_MARKETING_REPORTS_FETCH_SUCCESS:
            return state.mergeDeepIn(['byId', action.payload.isin], {
                marketingUrl: action.payload.url,
            });
        case actionTypes.CM_LEGAL_DOCUMENT_COST_FETCH_SUCCESS:
            return state.mergeDeepIn(['byId', action.payload.response.isin], {
                fundTransactionCostObjectId: action.payload.response.objectId,
                fundTransactionCostBase64Data: action.payload.response.content,
            });
        case actionTypes.CM_LEGAL_UNIFIED_DOCUMENT_FETCH_SUCCESS:
            const fundInfo = {
                unifiedDocumentUrl: action.payload.url,
                isFetched: true,
                isFetching: false,
            };
            return state.mergeDeep({
                byId: {
                    [action.payload.isin]: fundInfo,
                },
                activeIsin: action.payload.isin,
            });
        default:
            return state;
    }
}

module.exports = cmLegalDocumentsReducer;
